import React from 'react'

function Second() {
  return (
    <section className="second">
    <div className="container">
        <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
            <div className="left-col">
                <p className="text">
                    Tämä sosiaalinen kasino on suunniteltu sekä aloittelijoille että kokeneille pelaajille. Se tarjoaa monia bonuksia ja mahdollisuuksia paljastaa salaisuuksia ja piilotettuja palkintoja. Jokainen uusi taso antaa sinulle mahdollisuuden kehittää taitojasi samalla, kun nautit upeista visuaalisista tehosteista ja mukaansatempaavasta äänimaailmasta. Crazy Monkey Slot on enemmän kuin vain peli – se on kokonaisvaltainen kokemus, joka vangitsee huomiosi ensimmäisestä pyöräytyksestä lähtien.
                </p>
            </div>
            <div className="right-col">
                <img src="/2_(2).jpg" alt="Crazy Monkey Slot -peli"/>
            </div>
        </div>
        <p className="text text-md">
            Pelin houkutteleva ulkoasu ja juhlatunnelma luovat virtuaalisen kokemuksen, jossa jokainen pelaaja voi nauttia jännittävästä ja viihdyttävästä pelattavuudesta. Crazy Monkey Slot antaa sinulle mahdollisuuden kokea voittamisen iloa ilmaisessa peliympäristössä samalla, kun sukellat jännityksen ja hauskuuden maailmaan. Jokainen pelikerta paljastaa uusia salaisuuksia ja piilotettuja palkintoja tarjoten ainutlaatuisen yhdistelmän mukavuutta ja nautintoa.
        </p>
    </div>
</section>

  )
}

export default Second